import AccessGroupAddApartmentModal from './AccessGroupAddApartmentModal';

export default AccessGroupAddApartmentModal;
